export const TERRITORIES = ['Harare', 'Bulawayo', 'Manicaland', 'Mashonaland East', 'Mashonaland West', 'Matabeleland South', 'Midlands', 'Masvingo'];

export const CAMPAIGNS = [
  {
    campaignName: 'Heart Health Drive', productSku: 'HET-2001', productName: 'Cardiopril 10',
    startDate: '2026-06-01', endDate: '2026-08-31', reach: 8400, effectivenessScore: 62, adoptionRate: 18,
    territoryPerformance: [
      { territory: 'Harare', performanceScore: 71 }, { territory: 'Bulawayo', performanceScore: 58 },
      { territory: 'Manicaland', performanceScore: 49 }, { territory: 'Midlands', performanceScore: 55 },
    ],
  },
  {
    campaignName: 'Diabetes Care Outreach', productSku: 'HET-3002', productName: 'Insulet Mix 30/70',
    startDate: '2026-05-15', endDate: '2026-09-15', reach: 5200, effectivenessScore: 58, adoptionRate: 21,
    territoryPerformance: [
      { territory: 'Harare', performanceScore: 66 }, { territory: 'Mashonaland East', performanceScore: 52 },
      { territory: 'Masvingo', performanceScore: 44 },
    ],
  },
  {
    campaignName: 'Immunity Season', productSku: 'HET-5001', productName: 'Vitahet C 1000',
    startDate: '2026-06-01', endDate: '2026-09-10', reach: 6100, effectivenessScore: 54, adoptionRate: 15,
    territoryPerformance: [
      { territory: 'Harare', performanceScore: 60 }, { territory: 'Bulawayo', performanceScore: 51 },
      { territory: 'Mashonaland West', performanceScore: 47 }, { territory: 'Matabeleland South', performanceScore: 38 },
    ],
  },
  {
    campaignName: 'Pain Relief Awareness', productSku: 'HET-4001', productName: 'Painex-Het 400',
    startDate: '2026-07-01', endDate: '2026-08-15', reach: 4700, effectivenessScore: 49, adoptionRate: 12,
    territoryPerformance: [
      { territory: 'Harare', performanceScore: 55 }, { territory: 'Manicaland', performanceScore: 46 },
      { territory: 'Midlands', performanceScore: 41 },
    ],
  },
];
